import { Skeleton } from "@/app/admin/_common/ui/skeleton";

export default function LocationsMapSkeleton() {
  return (
    <Skeleton className="h-full max-h-[calc(100vh-180px)] min-h-[calc(100vh-180px)] w-full rounded-md border border-border" />
  );
}
